



import { Component, Prop } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import ProductMigrationLogState from '@/models/Products/ProductMigrations/ProductMigrationLogState';

@Component({ name: 'ProductMigrationLogState', })
export default class extends SaascadaVue {

    @Prop({ required: true })
    state: ProductMigrationLogState;

    get textColor() {
        var color: string = "grey--text";
        switch (this.state) {
            case ProductMigrationLogState.Information:
                color = "info--text";
                break;
            case ProductMigrationLogState.Warning:
                color = "warning--text";
                break;
            case ProductMigrationLogState.Error:
                color = "error--text";
                break;
        }
        return color;
    }

}
